export default __webpack_public_path__ + "static/media/smedetoften-tenancy-15.86057d9b.jpg";